import { Box, Grid, Paper, Typography } from '@mui/material'
import React from 'react'
import { isISODateString } from '../services'
import moment from 'moment'

const Header1 = (props) => {

    const { commonStyle, data: headerData, companyHeading = true, rows = {} } = props
    const { heading = {}, typography = {} } = commonStyle

    const companyName = headerData?.headerData?.companyName ?? "N/A"

    return (
        <Box>
            <Grid
                component={Paper}
                container
                sx={{
                    width: "100%",
                    boxShadow: "none",
                    borderRadius: '0px'
                }}
            >
                {
                    companyHeading && (
                        <Grid
                            item
                            xs={12}
                            sx={{
                                ...heading,
                            }}
                        >
                            <Typography sx={{ fontSize: heading?.fontSize }}>
                                {headerData?.headerData?.companyName}
                            </Typography>
                        </Grid>
                    )
                }
                <Grid
                    item
                    xs={12}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                        }}
                    >
                        {
                            headerData?.headerFields?.map((field) => {
                                return (
                                    <Box sx={{ minWidth: '100px', flexGrow: 1 }} >
                                        <Typography sx={{ ...heading }}>{field?.name}</Typography>
                                        <Typography sx={{ ...typography }} >
                                            {
                                                field?.uniqueName === "companyName"
                                                    ? companyName
                                                    : isISODateString(rows[field?.uniqueName])
                                                        ? moment(rows[field?.uniqueName]).format("DD/MM/YYYY")
                                                        : rows[field?.uniqueName]

                                                        ?? "N/A"
                                            }
                                        </Typography>
                                    </Box>
                                )
                            })
                        }
                    </Box>

                </Grid>
            </Grid>
        </Box>
    )
}

export default Header1
